import "./PaymentSection.css";

function PaymentSection({
  paymentMethod,
  setPaymentMethod
}) {

  const paymentOptions = [

    {
      id: "COD",
      icon: "💵",
      title: "Cash On Delivery",
      description: "Pay when your order is delivered.",
      available: true
    },

    {
      id: "UPI",
      icon: "📱",
      title: "UPI Payment",
      description: "Google Pay, PhonePe, Paytm & BHIM.",
      available: false
    },

    {
      id: "CARD",
      icon: "💳",
      title: "Credit / Debit Card",
      description: "Visa, RuPay, MasterCard and more.",
      available: false
    }

  ];


  return (

    <section className="payment-section">

      {/* =====================================================
          HEADER
      ===================================================== */}

      <div className="payment-header">

        <div className="payment-heading">

          <div className="payment-header-icon">
            💳
          </div>

          <div>

            <h2>
              Payment Method
            </h2>

            <p>
              Choose your preferred payment option.
            </p>

          </div>

        </div>

      </div>


      {/* =====================================================
          INFO
      ===================================================== */}

      <div className="payment-info">

        <span className="payment-info-icon">
          ℹ️
        </span>

        <span>
          Your payment is processed securely.
          More payment methods will be available soon.
        </span>

      </div>


      {/* =====================================================
          PAYMENT OPTIONS
      ===================================================== */}

      <div className="payment-options">

        {paymentOptions.map((option) => (

          <button
            type="button"
            key={option.id}
            className={

              option.available

                ? (
                    paymentMethod === option.id
                      ? "payment-card active"
                      : "payment-card"
                  )

                : "payment-card disabled"

            }
            onClick={() => {

              if (option.available) {

                setPaymentMethod(option.id);

              }

            }}
            disabled={!option.available}
          >

            {/* ===============================================
                LEFT
            =============================================== */}

            <div className="payment-left">

              <div className="payment-icon">

                {option.icon}

              </div>


              <div className="payment-text">

                <div className="payment-title">

                  {option.title}

                </div>


                <div className="payment-desc">

                  {option.description}

                </div>


                {!option.available && (

                  <div className="coming-soon">

                    Coming Soon

                  </div>

                )}

              </div>

            </div>


            {/* ===============================================
                RIGHT
            =============================================== */}

            <div className="payment-right">

              {option.available ? (

                <div
                  className={
                    paymentMethod === option.id
                      ? "payment-check selected"
                      : "payment-check"
                  }
                >

                  {paymentMethod === option.id
                    ? "✓"
                    : ""}

                </div>

              ) : (

                <div className="payment-tag">

                  Soon

                </div>

              )}

            </div>

          </button>

        ))}

      </div>


      {/* =====================================================
          SECURITY
      ===================================================== */}

      <div className="payment-security">

        <div className="security-icon">

          🔒

        </div>


        <div className="security-text">

          <div className="security-title">

            Secure Checkout

          </div>


          <div className="security-desc">

            Your payment and personal information are
            protected using secure encryption.

          </div>

        </div>

      </div>


      {/* =====================================================
          COD INFORMATION
      ===================================================== */}

      {paymentMethod === "COD" && (

        <div className="payment-delivery-estimate">

          <div className="payment-delivery-icon">

            💵

          </div>


          <div className="payment-delivery-info">

            <div className="payment-delivery-title">

              Cash On Delivery

            </div>


            <div className="payment-delivery-note">

              Pay with cash when your order arrives
              at your doorstep.

            </div>

          </div>

        </div>

      )}

    </section>

  );

}

export default PaymentSection;